import Typography from "ds/components/Typography";

type ChangeHistoryCardTimeLabelProps = {
  timeLabel: string;
};

const ChangeHistoryCardTimeLabel = ({ timeLabel }: ChangeHistoryCardTimeLabelProps) => (
  <Typography tag="span" variant="p-body3" color="secondary">
    {timeLabel}
  </Typography>
);

export default ChangeHistoryCardTimeLabel;
